import React from 'react';

export function SvgIcon({
  iconPath,
  width = 14,
  height,
  color = '#ffffff',
  ...props
} = {}) {
  return (
    <svg
      width={width}
      height={height && width}
      color={color}
      {...props}
    >
      <use href={iconPath} />
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/snippets/SvgIcon.jsx